import styled from 'styled-components';

interface ContentProps {
  size: 'md' | 'lg' | 'xl' | string;
}

export const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);

  > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Content = styled.div<ContentProps>`
  width: 95%;
  max-width: ${({ size }) => {
    switch (size) {
      case 'xl':
        return '100rem';
      case 'lg':
        return '80rem';
      case 'md':
        return '50rem';
      default:
        return size;
    }
  }};
  height: 100%;
  max-height: 63rem;
  overflow-y: auto;
  word-break: break-all;
  position: relative;
  padding: 4rem 3.2rem 3.2rem;
  background: #fff;
  border-radius: 0.8rem;

  @media (max-width: 600px) {
    padding: 4rem 1.6rem 3.2rem;
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  border: none;
  background: transparent;
  top: 0.8rem;
  right: 0.8rem;
  padding: 0.4rem 1.2rem;
  font-size: 2.4rem;
  border-radius: 0.8rem;
  transition: background 200ms;
  color: #c1c1c1;

  &:hover {
    background: #f5f5f5;
  }
`;
